export default "__VITE_ASSET__UlOqw0yv__";